<div class="w-full bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <p-confirmDialog
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
    [style]="{width: '50vw'}"
    acceptLabel="Sí"
    rejectLabel="Cancelar"
    rejectButtonStyleClass="p-button-danger">
  </p-confirmDialog>

  <div class="flex flex-column md:flex-row justify-content-between align-items-center gap-3 mb-5">

    <span class="p-input-icon-left w-full md:w-auto">
        <input pInputText type="text"
               (input)="dt.filterGlobal($any($event.target).value, 'contains')"
               placeholder="Buscar método..."
               class="w-full md:w-20rem border-round-3xl pl-5" />
    </span>

    <button pButton label="Nuevo Método" icon="pi pi-plus" class="p-button-black  border-round-3xl" (click)="openNew()"></button>
  </div>

  <p-table #dt [value]="methods" [rows]="10" [paginator]="true"
           [globalFilterFields]="['name', 'holderName', 'accountNumber']"
           [tableStyle]="{ 'min-width': '50rem' }"
           [rowHover]="true"
           styleClass="p-datatable-sm">

    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th style="width: 20%">Método</th>
        <th style="width: 15%">Tipo</th>
        <th style="width: 30%">Detalles</th>
        <th style="width: 15%">QR</th>
        <th style="width: 10%" class="text-center">Estado</th>
        <th class="text-center" style="width: 10%">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr class="text-sm transition-colors hover:surface-50">
        <td class="font-bold text-900">{{item.name}}</td>

        <td>
          <p-tag [value]="item.type === 'QR' ? 'Billetera' : 'Banco'"
                 [severity]="item.type === 'QR' ? 'warn' : 'info'"
                 [rounded]="true"></p-tag>
        </td>

        <td>
          <div class="font-medium text-900">N°: {{item.accountNumber}}</div>
          <div class="text-xs text-600 mt-1">{{item.holderName}}</div>
        </td>

        <td>
          <img *ngIf="item.type === 'QR' && item.qrImage"
               [src]="item.qrImage" width="40" height="40"
               class="border-round shadow-1 cursor-pointer hover:shadow-3 transition-all object-cover"
               (click)="imagePreview = item.qrImage; showImageDialog = true" />
          <span *ngIf="item.type === 'BANK'" class="text-400 text-xs italic">-</span>
        </td>

        <td class="text-center">
            <span [class]="'text-xs font-bold px-2 py-1 border-round cursor-pointer ' + (item.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600')"
                  (click)="toggleStatus(item)">
                {{item.isActive ? 'ACTIVO' : 'INACTIVO'}}
            </span>
        </td>

        <td class="text-center">
          <div class="flex justify-content-center gap-2">
            <button pButton icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger hover:bg-red-50"
                    (click)="deleteMethod(item)" pTooltip="Eliminar"></button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr><td colspan="6" class="text-center p-5 text-500">No hay métodos de pago registrados.</td></tr>
    </ng-template>
  </p-table>

  <p-dialog [(visible)]="methodDialog" [style]="{width: '450px'}" header="Detalles del Método" [modal]="true"
            [breakpoints]="{'960px': '75vw', '640px': '95vw'}" styleClass="p-fluid" [draggable]="false" [resizable]="false">

    <div class="flex flex-column gap-3 pt-2">

      <div class="field">
        <label class="font-bold text-900 mb-2 block">Tipo</label>
        <div class="flex gap-3">
          <div class="field-radiobutton flex-1 p-3 border-1 border-gray-200 border-round hover:surface-50 cursor-pointer" (click)="method.type = 'QR'">
            <p-radioButton name="type" value="QR" [(ngModel)]="method.type" inputId="type1"></p-radioButton>
            <label for="type1" class="ml-2 cursor-pointer font-medium">QR (Yape/Plin)</label>
          </div>
          <div class="field-radiobutton flex-1 p-3 border-1 border-gray-200 border-round hover:surface-50 cursor-pointer" (click)="method.type = 'BANK'">
            <p-radioButton name="type" value="BANK" [(ngModel)]="method.type" inputId="type2"></p-radioButton>
            <label for="type2" class="ml-2 cursor-pointer font-medium">Banco</label>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="font-bold text-900">Nombre</label>
        <input pInputText [(ngModel)]="method.name" placeholder="Ej: BCP, Yape" required />
        <small class="p-error block mt-1" *ngIf="submitted && !method.name">Nombre requerido.</small>
      </div>

      <div class="field" *ngIf="method.type === 'QR'">
        <label class="font-bold text-900">Link del QR</label>
        <input pInputText [(ngModel)]="method.qrImage" placeholder="https://..." />
        <div *ngIf="method.qrImage" class="mt-2 text-center bg-gray-50 p-2 border-round">
          <img [src]="method.qrImage" class="w-4rem border-round shadow-1" />
        </div>
      </div>

      <div class="field">
        <label class="font-bold text-900">N° Cuenta / Celular</label>
        <input pInputText [(ngModel)]="method.accountNumber" required />
      </div>

      <div class="field">
        <label class="font-bold text-900">Titular</label>
        <input pInputText [(ngModel)]="method.holderName" />
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900" (click)="methodDialog = false"></button>
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-black" (click)="saveMethod()"></button>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showImageDialog" header="Código QR" [modal]="true" [style]="{width: '300px'}" [draggable]="false" [resizable]="false">
    <div class="flex justify-content-center" *ngIf="imagePreview">
      <img [src]="imagePreview" class="w-full border-round shadow-2" />
    </div>
  </p-dialog>
</div>
